import { jsx as _jsx } from "react/jsx-runtime";
import { useOverlayContext } from 'seagull';
import { SelectProposalTypeModal } from '~/components/SelectProposalTypeModal/SelectProposalTypeModal';
import { useProposalTemplates } from './reactQuery/queries/useProposalTemplates';
import { useRedirectToProposal } from './useCreateAgreement';
export function useOpenNewProposal() {
    const { templates, isLoading } = useProposalTemplates({
        refreshOnMount: true
    });
    const { openCreationModal } = useRedirectToProposal();
    const { showModal } = useOverlayContext();
    const hasProposalTemplates = !!(templates === null || templates === void 0 ? void 0 : templates.length);
    function openSelectProposalTypeModal(proposalType) {
        showModal({
            closeOnClickOutside: true,
            closeOnEscapeKey: true,
            openBottomSheetOnMobile: true,
            hideBottomSheetOnDismiss: true,
            content: (param)=>{
                let { dismissModal } = param;
                return /*#__PURE__*/ _jsx(SelectProposalTypeModal, {
                    dismissModal: dismissModal,
                    proposalType: proposalType
                });
            }
        });
    }
    async function openNewProposal() {
        if (hasProposalTemplates) {
            openSelectProposalTypeModal();
        } else {
            await openCreationModal();
        }
    }
    return {
        isLoadingProposalTemplates: isLoading,
        hasProposalTemplates,
        openNewProposal,
        openSelectProposalTypeModal
    };
}
